import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // margin: '40px 40px 24px',
    flexDirection: 'column',
    height: '80vh'
  },
  title: {
    fontSize: '10rem',
    color: '#F37320',
    fontWeight: 'bolder',
    textShadow: '10px 6px 8px #757575cc'
  },
  content: {
    fontSize: '2rem',
    color: '#335977',
    padding: '30px 0',
    textAlign: 'center'
  }
}))

export { useStyles }